// Dependencies
import React from 'react';

// Internal Components
import LogoOnlyLayout from './LogoOnlyLayout';
import PanelLayout from './dashboard';
import AuthGuard from 'src/guards/AuthGuard';
import GlobalStyles from '@mui/material/GlobalStyles';

// Types
type Props = {
  children?: React.ReactNode;
  variant?: 'main' | 'dashboard' | 'logoOnly';
};

/**
 * Layout component
 */
function Layout({ variant, children }: Props) {
  // =={ Styles }===============================================================
  const globalStyles = (
    <GlobalStyles
      styles={(theme) => [
        {
          body: {
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.primary,
          },
        },
        `
        input:-webkit-autofill,
        input:-webkit-autofill:hover,
        input:-webkit-autofill:focus,
        input:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px ${theme.palette.background.paper} inset !important;
        }
        select:-webkit-autofill,
        select:-webkit-autofill:hover,
        select:-webkit-autofill:focus,
        select:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px ${theme.palette.background.paper} inset !important;
        }
        textarea:-webkit-autofill,
        textarea:-webkit-autofill:hover,
        textarea:-webkit-autofill:focus,
        textarea:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px ${theme.palette.background.paper} inset !important;
        }
        `,
      ]}
    />
  );

  // =={ Renders }===============================================================
  if (variant === 'logoOnly') {
    return (
      <LogoOnlyLayout>
        {globalStyles}
        {children}
      </LogoOnlyLayout>
    );
  }

  if (variant === 'main') {
    return (
      <LogoOnlyLayout useBackground useLanguage useTheme>
        {globalStyles}
        {children}
      </LogoOnlyLayout>
    );
  }

  return (
    <PanelLayout>
      {globalStyles}
      <AuthGuard>{children}</AuthGuard>
    </PanelLayout>
  );
}

export default Layout;
